import { useEffect, useState } from "react";
import { ReactComponent as InforCircle } from "assets/images/svgs/info-circle.svg";
import bgAttendess from "assets/images/others/host-side-images/bgAttendess.png";
import { useLocation, useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes";
import AttendeeBreadcrumb, {
  AttendeBreadcrumbLink,
} from "components/breadcrumbs/AttendeeBreadcrumb";
import { MinorDTO } from "utils/helpers/models/attendee/minor.dto";
import { AddMinorToEventDTO } from "utils/helpers/models/attendee/add-minor-to-event.dto";
import useUtils from "hooks/useUtils";
import useHost from "containers/host/useHooks";
import { EventDTO } from "utils/helpers/models/shared/event.dto";
import { useSelector } from "react-redux";
import { JoiningFilterDTO } from "utils/helpers/models/attendee/joining-filter-dto";
import useAttendee from "containers/attendee/useHooks";
import { DeleteIcon } from "assets/images/svgs";
import ExperienceDetailHeader from "components/experience-detail-header";
import useStore from "hooks/useStore";

const AttendeeJoinAndPay = () => {
  const location = useLocation();

  const selectedMinors = location.state?.selectedMinors || [];
  const eventId = location.state?.eventId;
  const acceptPolicy = location.state?.acceptPolicy;
  console.log(selectedMinors, "selectedMinors");

  const breadcrumbLinks: AttendeBreadcrumbLink[] = [
    { title: "Home ", path: siteRoutes.attendeeHome },
    { title: "Pay and Join", path: siteRoutes.attendeeJoinAndPay },
  ];
  const [workshopSessionModal, setWorkshopSessionModal] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const [event, setEvent] = useState<EventDTO>(new EventDTO());

  const {  addMinorToEvent } = useAttendee();
  const { getEventById } = useHost();
  const navigate = useNavigate();
  const [minorsList, setMinorsList] = useState(selectedMinors);
  const { isProfileCompleted } = useStore();
  console.log(minorsList, "minorsList");

  // Check profile completion on mount - redirect to home if not completed
  useEffect(() => {
    const profileCompleted = isProfileCompleted();
    if (!profileCompleted) {
      navigate(siteRoutes.attendeeHome, { replace: true });
    }
  }, [isProfileCompleted, navigate]);

  useEffect(() => {
    getEventById(eventId, setEvent);
  }, []);
  const MinorIds = minorsList.map((minor: any) => minor.id);
  const onSubmit = () => {
    const data: AddMinorToEventDTO = {
      minorId: MinorIds,
      acceptPolicy: acceptPolicy,
    };
    addMinorToEvent(eventId, data);
  };

  const goToHostDetail = () => {
    navigate(`${siteRoutes.attendeeHostProfileDetail}?id=${event.host.id}`);
  };

  const visibleSessions = event.workshopSessions.slice(0, 3);
  const hasMoreSessions = event.workshopSessions.length > 3;

  const handleRemove = (id: any) => {
    const filtered = minorsList.filter((m: any) => m.id !== id);
    setMinorsList(filtered);
    
    // Navigate back if no participants left
    if (filtered.length === 0) {
      navigate(-1);
    }
  };

  return (
    <div>
      <ExperienceDetailHeader
        event={event}
        breadcrumb={<AttendeeBreadcrumb links={breadcrumbLinks} />}
        onHostClick={goToHostDetail}
        onSeeMoreSessions={() => setWorkshopSessionModal(true)}
        visibleSessions={visibleSessions}
        hasMoreSessions={hasMoreSessions}
        gradientClass="host-bg-gradient"
      />
      <div className="container my-5">
        <div className="relative">
          <h3 className="text-blackie text-2xl font-medium mb-2 flex items-center gap-1">
            Select Participants
            <span
              className="cursor-pointer text-gray-500 hover:text-gray-700 relative flex"
              onMouseEnter={() => setIsTooltipVisible(true)}
              onMouseLeave={() => setIsTooltipVisible(false)}
            >
              <InforCircle />
            </span>
          </h3>
          {/* Tooltip */}
          {isTooltipVisible && (
            <div className="absolute w-[250px] bottom-18 left-20 p-4 rounded-lg  bg-primaryBlueBg text-white text-xs opacity-100 transition-opacity duration-300 z-10">
              <p className="text-xs">
                We understand unexpected cancellations may occur. However, out
                of respect for the host and other attendees, frequent
                cancellations, particularly from overbooking, may result in the
                family member profile being temporarily disabled.
              </p>
            </div>
          )}
          <p className="text-lightBlackText text-lg">
            Select Persons from your Family Members to join the Event.
          </p>
        </div>

        <div className="flex items-center flex-wrap gap-6 py-5">
          {minorsList.map((minor: any) => (
            <div
              style={{ backgroundImage: `url(${bgAttendess})` }}
              key={minor.id}
              className="relative flex flex-col items-center justify-center p-6 rounded-[18px] cursor-pointer transition-all duration-300 border w-[235px] h-[260px]"
            >
              <img
                src={minor.profilePicUrl}
                alt={`${minor.firstName} ${minor.lastName}`}
                className="w-[110px] h-[110px] rounded-full mx-auto"
              />
              <p className="text-center mt-2 font-semibold text-black">
                {minor.firstName} {minor.lastName}
              </p>

              <button
                className="absolute top-2 right-2 text-red-500 hover:text-red-700"
                onClick={() => handleRemove(minor.id)}
              >
                <DeleteIcon />
              </button>
            </div>
          ))}
        </div>

        {minorsList.length > 0 && event?.entryFee > 0 && (
          <>
            <div className="border border-borderColor rounded-lg my-5">
              <div className="bg-primaryBlueBg py-3 px-4 text-white text-lg font-bold rounded-t-lg">
                Invoice Summary
              </div>
              <div className="flex flex-col gap-0">
                <div className="flex justify-between gap-6 pt-3 px-4">
                  <p className="text-primary text-lg font-medium">
                    Number of Participants
                  </p>
                  <p className="text-primary text-lg font-medium">
                    {minorsList?.length} {minorsList?.length === 1 ? 'Participant' : 'Participants'}
                  </p>
                </div>
                <div className="flex justify-between gap-6 py-3 px-4">
                  <p className="text-primary text-lg font-medium">Event Fee</p>
                  <p className="text-primary text-lg font-medium">
                    ${event?.entryFee?.toFixed(2)} per person
                  </p>
                </div>
                <div className="flex justify-between gap-6  bg-borderColor py-3 rounded-b-lg">
                  <p className="text-primaryBlueText text-lg font-medium  px-4">
                    Total
                  </p>
                  <p className="text-primaryBlueText text-lg font-medium  px-4">
                    ${(event?.entryFee * minorsList?.length)?.toFixed(2)}
                  </p>
                </div>
              </div>
            </div>
          </>
        )}

        <button
          onClick={onSubmit}
          className="bg-primaryBlueText px-4 py-2 text-white rounded-full mt-6 disabled:bg-gray-300"
          disabled={!minorsList.length}
        >
          Confirm
        </button>
      </div>
    </div>
  );
};

export default AttendeeJoinAndPay;
